import app from './app';
import { saveAs } from 'file-saver';
import { CATALOG_SERVICE_URL } from '../../libs/constants';

//POST
export const getPriceUploadList = (requestData, userId, type) => async (dispatch, getState, api) => {
    dispatch(setListRefreshed(false));

    const headerConfig = {
        headers: {
            "HW-Fetch-Type": "getPriceUploadList"
        }
    };

    await api.post(CATALOG_SERVICE_URL + `priceList/${type}/list/` + userId, requestData, headerConfig)
    .then(response => {
        if (response.data.bulkUploadList || response.data.priceUploadList) {
            dispatch({
                type: "SET_CUSTOMER_PRICE_UPLOAD_LIST",
                payload: response.data
            });
        }
        else {
            dispatch(setAPIFetchError(true));     
            dispatch(setListRefreshed(true));
        }
    })    
    .catch(error => {   
        dispatch(setAPIFetchError(true));     
        dispatch(setListRefreshed(true));
    });
};

//POST
export const approvePriceList = (requestData, userId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const headerConfig = {
        headers: {
            "HW-Fetch-Type": "approvePriceList"
        }
    };

    await api.post(CATALOG_SERVICE_URL + "priceList/approve/" + userId, requestData, headerConfig)
    .then(response => {
        if (response.data.id) {
            dispatch({
                type: "SET_CUSTOMER_PRICE_LIST_APPROVAL_RESPONSE",
                payload: response.data
            });
        }
        else {
            dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
        }
        dispatch(app.setLoading(false));
    })    
    .catch(error => {  
        if(error.response && error.response.data && error.response.data.errorCode && error.response.data.errorCode === 404) {    
            dispatch(app.setAppModal({ type: "error", messageId: "invalid_service_request" }));
            dispatch({
                type: "SET_CUSTOMER_PRICE_LIST_APPROVAL_RESPONSE",
                payload: { error: true }
            });
        } 
        else {
            dispatch(app.setAppModal({ type: "error", messageId: "price_list_error_message" }));
        }
        dispatch(app.setLoading(false));
    });
};


export const uploadFile = (requestData, userId, type) => async (dispatch, getState, api) => {
    dispatch(setPriceUploadInProgress());
    const headerConfig = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }
    
    await api.post(CATALOG_SERVICE_URL + `priceList/${type}/upload/` + userId, requestData, headerConfig)
    .then(response => {
        if (response.data.toLowerCase().indexOf("success") !== -1) {
            dispatch(setPriceUploadComplete());
        }
        else {
            dispatch(setPriceUploadError(response.data));
        }
    })
    .catch(error => {   
        dispatch(setPriceUploadError());
        if(error.response && error.response.data && error.response.data.message) {    
            dispatch(setpriceUploadTaskErrorCode(error.response.data.message));  
        }
    });
}

//POST 
const downloadTemplate = (type) => async (dispatch, getState, api) => {
    setPriceUploadTemplateDownloadError(false);
    let headerConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        },
        responseType: "blob" 
    };

    const templateName = (type === "priceList") ? "price_upload_template" : (type === "serviceRateCard") ? "customer-service-rate-card" : "exchange_rate_upload_template";

    await api.post(CATALOG_SERVICE_URL +  `priceList/direct/${type}/download`, null, headerConfig)
    .then(response => {
        saveAs(new Blob([response.data]), templateName + ".xlsx");
        dispatch(setPriceUploadTemplateDownloadError(false));
    })
    .catch(error => {
        dispatch(setPriceUploadTemplateDownloadError(true));
        // don't show error message in popup as pop up is already open for price upload
    });
};


const setListRefreshed = isRefreshed => {
    return {
        type: 'SET_CUSTOMER_LIST_REFRESHED',
        data: isRefreshed
    }
}

const setAPIFetchError = isError => {
    return {
        type: 'SET_CUSTOMER_API_FETCH_ERROR',
        data: isError
    }
}

const setPriceUploadInProgress = () => {
    return {
        type: 'SET_CUSTOMER_PRICE_UPLOAD_IN_PROGRESS'
    }
}

const setPriceUploadComplete = () => {
    return {
        type: 'SET_CUSTOMER_PRICE_UPLOAD_COMPLETE'
    }
}

const setPriceUploadError = (errorDesc) => {
    return {
        type: 'SET_CUSTOMER_PRICE_UPLOAD_ERROR',
        errorDesc: errorDesc
    }
}

const setPriceUploadTemplateDownloadError = isError => {
    return {
        type: 'SET_CUSTOMER_PRICE_UPLOAD_TEMPLATE_DOWNLOAD_ERROR',
        data: isError
    }
}

const setpriceUploadTaskErrorCode = code => {
    return {
        type: 'SET_CUSTOMER_PRICE_UPLOAD_TASK_ERROR_CODE',
        data: code
    }
}

const resetPriceUploadTask = () => {
    return {
        type: 'RESET_CUSTOMER_PRICE_UPLOAD_TASK'
    }
}

const priceListActions = {
    getPriceUploadList: getPriceUploadList, 
    setListRefreshed: setListRefreshed, 
    setAPIFetchError: setAPIFetchError, 
    uploadFile: uploadFile,
    downloadTemplate: downloadTemplate,
    setPriceUploadComplete: setPriceUploadComplete,
    setPriceUploadError: setPriceUploadError,
    setPriceUploadTemplateDownloadError: setPriceUploadTemplateDownloadError,
    resetPriceUploadTask: resetPriceUploadTask,
    setPriceUploadInProgress: setPriceUploadInProgress,
    setpriceUploadTaskErrorCode: setpriceUploadTaskErrorCode,
    approvePriceList: approvePriceList
}

export default priceListActions;